import React from "react";
import { Card, Row } from "antd";
import DocumentFiltersContainer from "@/common/document-filters/document-filters-component";
import { CartFilter } from "@/pages/cart-management/cart.lazy";

const FilterComponent = ({
  isDocumentsTab,
  isCartTab,
  showFilterPanel,
  filterRef,
  resetSearchValues,
  handleFilterSearch,
  mobileView,
  showFilterDrawer,
  filters,
  selectedItems,
  updateTotalDocumentCount,
  activeTabKey,
  tableCount,
  columnOptions,
  selectedColumns,
  setEnabledColumns,
  onColumnClearment,
  onReorder,
  isThumbnailView,
  tableViewVisible,
  setLargeTableView,
  setThumbnailTableView,
  pageSize,
  width,
  setAltSearch,
  altSearch,
  setDescriptionSearch,
  setDdvSearch,
  ddvSearch,
  closeFilterDrawer,
  descriptionSearch,
  filterActionRef,
  tableId,
  props,
}) => {
  if (!showFilterPanel) return null;

  // Determine if this is favorites tab by exclusion
  const isFavouritesTab = !isDocumentsTab && !isCartTab;

  return (
    <Row style={{ height: "100%" }}>
      <Card
        ref={filterRef || null}
        style={{ height: "100%" }}
        className="top-filter-card"
      >
        {isDocumentsTab ? (
          <DocumentFiltersContainer
            filtersOnTop
            key="documentFilters"
            table={tableId}
            mobileView={mobileView}
            showFilterDrawer={showFilterDrawer}
            resetSearch={resetSearchValues}
            handleSearch={handleFilterSearch}
            filters={filters}
            updateTotalDocumentCount={updateTotalDocumentCount}
            activeTabKey={activeTabKey}
            tableCount={tableCount}
            pageSize={pageSize}
            columnOptions={columnOptions}
            selectedColumns={selectedColumns}
            setEnabledColumns={setEnabledColumns}
            onColumnClearment={onColumnClearment}
            onReorder={onReorder}
            isThumbnailView={isThumbnailView}
            isDocumentsTab={isDocumentsTab}
            tableViewVisible={tableViewVisible}
            setLargeTableView={setLargeTableView}
            setThumbnailTableView={setThumbnailTableView}
            isCartTab={isCartTab}
            width={width}
            setDdvSearch={setDdvSearch}
            setAltSearch={setAltSearch}
            altSearch={altSearch}
            setDescriptionSearch={setDescriptionSearch}
            closeFilterDrawer={closeFilterDrawer}
            ddvSearch={ddvSearch}
            descriptionSearch={descriptionSearch}
            filterActionRef={filterActionRef}
            filterRef={filterRef}
            {...props}
          />
        ) : isCartTab && selectedItems && selectedItems.length > 0 ? (
          <CartFilter
            isTop
            mobileView={mobileView}
            showFilterDrawer={showFilterDrawer}
            width={width}
            closeFilterDrawer={closeFilterDrawer}
          />
        ) : (
          <DocumentFiltersContainer
            updateTotalDocumentCount={updateTotalDocumentCount}
            filtersOnTop
            includeCart={!isFavouritesTab}
            favouritesOnly={isFavouritesTab}
            key={isFavouritesTab ? "favouritesFilters" : "cartFilters"}
            table={tableId}
            mobileView={mobileView}
            showFilterDrawer={showFilterDrawer}
            resetSearch={resetSearchValues}
            handleSearch={handleFilterSearch}
            filters={filters}
            width={width}
            closeFilterDrawer={closeFilterDrawer}
            {...props}
          />
        )}
      </Card>
    </Row>
  );
};

export default FilterComponent;
